/** The buyer and card contracts are Identity's contracts package's: this
 *  package re-exports them for its clients. */
export * from "@libs/identity-onboarding-contracts/buyer";
export * from "@libs/identity-onboarding-contracts/card";

/** `brandId` is computed when a saved card is read, from the vault's brand
 *  string (`cardBrandIdOf`); no column holds it. */
export { cardBrandIdOf } from "@libs/identity-onboarding-contracts/card-brands";
